import { useMemo } from "react";

export function useWholesaleDataCheck(data: any[], options?: { selectedMonth?: string; selectedCategory?: string }) {
  const { selectedMonth, selectedCategory } = options || {};

  // Memoized data for revenue (if applicable)
  const monthlyChartData = useMemo(() => {
    if (!data || !selectedMonth) return [];
    return data.map((item: { period: string; total_revenue: number }) => ({
      month: item.period,
      revenue: item.total_revenue,
    }));
  }, [data, selectedMonth]);

  // Memoized data for performance (if applicable)
  const categoryChartData = useMemo(() => {
    if (!data || !selectedCategory) return [];
    return data.map((item: { category: string; revenue: number }) => ({
      category: item.category,
      revenue: item.revenue,
    }));
  }, [data, selectedCategory]);

  // Check if data exists for the selected month
  const hasDataForSelectedMonth = useMemo(() => {
    if (!selectedMonth || !monthlyChartData.length) return false;
    return monthlyChartData.some((item) => item.month === selectedMonth);
  }, [monthlyChartData, selectedMonth]);

  // Check if data exists for the selected category
  const hasDataForSelectedCategory = useMemo(() => {
    if (!selectedCategory || !categoryChartData.length) return false;
    return categoryChartData.some((item) => item.category === selectedCategory);
  }, [categoryChartData, selectedCategory]);

  // Check if there is any data at all
  const hasAnyData = useMemo(() => {
    return data && data.length > 0;
  }, [data]);

  return {
    hasDataForSelectedMonth,
    hasDataForSelectedCategory,
    hasAnyData,
  };
}